<template lang="pug"> 
  v-row.mt-10.px-3(no-gutters)
    v-card.py-1(flat width='100%')
      v-card-title.mx-3
        h4 {{ $t('waiting-withdraw') }}
      v-divider
      v-card-text
        v-row(no-gutters justify="center") 
          v-col(cols=12 md=8) 
            h3.mx-3 {{ $t('withdraw-method') }}
            v-list-item
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 1
              v-list-item-content {{ $t('desc.withdrawing-from-account') }}
                b
                  mark.success--text {{ $t('status') }} {{ (bankInfo.status || {}).name }}
            .d-flex.justify-center.mt-2
              v-card(width='80%', outlined)
                v-row(no-gutters justify="center", align="center").px-4
                  v-col(cols=12 sm=6)
                    v-list-item
                      v-list-item-content {{ $t('account-name') }} 
                        b {{ bankInfo.user_bank_name }}
                        br
                        | {{ $t('account-number') }} 
                        .blue--text
                          | {{ bankInfo.user_bank_number }}
                        br
                        .mt-1
                          v-btn(
                            depressed 
                            small 
                            @click='copyAccountNumber()'
                          ) {{ $t('copy-account-number') }}
                        br
                        | {{ $t('total-withdraw') }} 
                        .blue--text {{ bankInfo.request_amount }}
                  v-col(v-if="bankInfo.user_bank_qr_image_url" cols=12 sm=6)
                    v-img(:src='bankInfo.user_bank_qr_image_url', width="100%")
            v-list-item.mt-2
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 2
              v-list-item-content  {{ $t('desc.keep-evidence-withdraw') }}
            v-list-item.mt-2
              v-avatar.mr-3(
                :color='secondIcon'
                size='30'
              )
                h2 3
              v-list-item-content {{ $t('desc.waiting-withdraw') }}

</template>
<script> 
import { getMinuteTime } from '@/plugins/time' 
import * as c from '@/const/setTimeOutConfig'
export default { 
  props : {
    bankInfo : {
      type : Object,
      default : null
    }
  },
  data () {
    return { 
      secondIcon:'grey',  
    } 
  },
  computed : {
    countDownTimeString () {
      return getMinuteTime(this.countDownTime)
    }
  },
  watch : {
    countDownTime () {
      if(this.countDownTime===0){
        this.$alert('',this.$t('message.timeout-deposit-confirm'),'error')   
      }
    }
  },   
  methods : {     
    copyAccountNumber () {
      this.$ga.event('Button', 'CoppyAccountNumber', 'WithdrawPage','' )
      this.copyAccountNumberText = this.$t('copied-account-number') 
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = this.bankInfo?.user_bank_name?.number;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);     
          
      setTimeout(()=>{ 
        this.copyAccountNumberText = this.$t('copy-account-number') 
      },c.COPYACCOUNTWITHDRAW) 
    },   
  }
}
</script> 